export default Object.freeze({ TOKEN: 'token' });
